import React from "react";
import "./Navigation.css";

const navigation = () => {
  return (
    <>
      <div className="wrap">
        <div className="nav">
          <nav className="bar">
            <div className="navbar">
              <ul>
                <li>
                  <a href="#menu">
                    <i className="bx bx-home-alt-2 navi"></i>
                  </a>
                </li>
                <li>
                  <a href="#expertise">
                    <i className="bx bx-book navi"></i>
                  </a>
                </li>
                <li>
                  <a href="#myprojects">
                    <i className="bx bx-briefcase navi"></i>
                  </a>
                </li>
                <li>
                  <a href="#contacts">
                    <i className="bx bxs-contact navi"></i>
                  </a>
                </li>
              </ul>
            </div>
          </nav>
        </div>
      </div>
    </>
  );
};

export default navigation;
